export const getUnlimitedQuantityRequiredText = (minimum, displayText, i18n) => {
    if (minimum === 0)
        return undefined;
    if (minimum === 1)
        return displayText.modifierQuantityLimitMinOneMaxUnlimitedLabel;
    if (minimum > 1) {
        return i18n.template(displayText.modifierQuantityLimitMinGreaterThanOneMaxUnlimitedLabel, { minimum });
    }
};
export const getLimitedQuantityRequiredText = (minimum, maximum, displayText, selectedQuantity, i18n) => {
    if (minimum === 0) {
        if (maximum === 1)
            return undefined;
        if (maximum > 1) {
            return i18n.template(displayText.modifierQuantityLimitMinZeroMaxGreaterThanOneLabel, { maximum });
        }
    }
    if (minimum === 1) {
        if (maximum === 1)
            return displayText.modifierQuantityLimitMinOneMaxOneLabel;
        if (maximum > 1) {
            return i18n.template(displayText.modifierQuantityLimitMinOneMaxGreaterThanOneLabel, { maximum });
        }
    }
    if (minimum > 1) {
        if (maximum > 1) {
            if (minimum === maximum) {
                return i18n.template(displayText.modifierQuantityLimitMinGreaterThanOneMaxGreaterThanOneAndMinEqualMaxLabel, { selectedQuantity, maximum });
            }
            return i18n.template(displayText.modifierQuantityLimitMinGreaterThanOneMaxGreaterThanOneLabel, {
                minimum,
                maximum
            });
        }
    }
};
